import { cloneElement, FC, KeyboardEvent, ReactElement } from 'react';
import { useCollapsible } from '../collapsible-context.ts';

export const CollapsibleButton: FC<{children: ReactElement}> = ({ children }) => {
  const { toggle } = useCollapsible();

  return cloneElement(children, {
    tabIndex: 0,
    onKeyDown: (e: KeyboardEvent) => {
      if (['Enter', ' '].includes(e.key)) {
        toggle();
        e.stopPropagation();
        e.preventDefault();
      }
    },
    onClick: (e: MouseEvent) => {
      e.stopPropagation();
      toggle();
    }
  });
};
